import { Stack } from '@chakra-ui/react';
import * as React from 'react';

import { Announcements } from '@/components/Announcements';
import { FeaturedSponsor } from '@/components/FeaturedSponsor';
import { MembershipRenewalModal } from '@/components/MembershipRenewalModal';
import { MembershipSupportingContent } from '@/components/MembershipSupportingContent';
import { PostFeed } from '@/components/PostFeed';
import { HappeningNow } from '@/components/PostFeed/components/HappeningNow';
import { UpcomingEvents } from '@/components/UpcomingEvents';
import { CreatePostButton } from '@/components/create-post/CreatePostButton';
import { usePermissions } from '@/hooks/usePermissions';
import { OnboardingChecklist } from '@/imports/ui/components/OnboardingChecklist';
import { Vanilla } from '@/layouts/Vanilla';
import { VanillaAside, VanillaMain } from '@/layouts/Vanilla/Vanilla';

export const CommunityFeed: React.FC = () => {
  const { canAccessEventsFeed } = usePermissions();

  return (
    <Vanilla>
      <VanillaMain>
        <Stack spacing="4">
          <CreatePostButton showFixedGroupName={false} />
          <Announcements />
          <HappeningNow />
          <PostFeed showRecentlyAddedSponsors={true} />
          <MembershipRenewalModal />
        </Stack>
      </VanillaMain>
      <VanillaAside>
        <Stack spacing="4">
          <OnboardingChecklist />
          <MembershipSupportingContent />
          <FeaturedSponsor />
          {canAccessEventsFeed && <UpcomingEvents />}
        </Stack>
      </VanillaAside>
    </Vanilla>
  );
};
